const myStyles = theme => ({
  input: {
    display: "none"
  },

  avatar: {
    width: "150px",
    height: "150px",
    [theme.breakpoints.down("sm")]: {
      width: "100px",
      height: "100px"
    },

    [theme.breakpoints.down("xs")]: {
      width: "60px",
      height: "60px"
    }
  },
  iconBtn: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "30px"
    },

    [theme.breakpoints.down("xs")]: {
      fontSize: "25px"
    }
  },
  unameInput: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  canvas: {
    display: "none"
  },

  img: {
      width:'512px',  
      visibility:'hidden',
      zIndex:-99
  }
});

export default myStyles;
